"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHoursAndMinutesFromDuration = exports.parseTravelTime = exports.isNumeric = exports.calculateTimeDifferenceBetween12HourStrings = exports.validateDate = exports.addTimeTo12HourFormat = exports.validate12HourFormatTime = exports.convertTimeTo24HourFormat = exports.convertDuration = exports.TIME_WIZARD_CSV_GENERATION_OPTIONS = void 0;
const luxon_1 = require("luxon");
exports.TIME_WIZARD_CSV_GENERATION_OPTIONS = {
    emptyFieldValue: '',
    keys: [
        {
            field: 'employeeId',
            title: 'Employee ID'
        },
        {
            field: 'startDate',
            title: 'Start Date of Paycode'
        },
        {
            field: 'endDate',
            title: 'End Date of Paycode'
        },
        {
            field: 'startTime',
            title: 'Start Time of Paycode'
        },
        {
            field: 'duration',
            title: 'Duration Per Day'
        },
        {
            field: 'businessLine',
            title: 'Business Line'
        },
        {
            field: 'paycodeType',
            title: 'Paycode Type'
        },
        {
            field: 'paycode',
            title: 'Paycode'
        },
        {
            field: 'reasonForDelay',
            title: 'Reason for Delay'
        },
        {
            field: 'infractRemoved',
            title: 'Does the Infraction/ASI need to be removed?'
        },
        {
            field: 'juryDuty',
            title: 'Reason for Jury Duty'
        },
        {
            field: 'paymentMode',
            title: 'Payment Mode'
        },
        {
            field: 'proxyId',
            title: 'Aline card number / Proxy ID  (Only applicable if Payment mode is Instant)'
        },
        {
            field: 'mealBreakStartTime',
            title: 'Meal Break Start Time (California employees only)'
        },
        {
            field: 'mealBreakEndTime',
            title: 'Meal Break End Time (California employees only)'
        },
        {
            field: 'justificationForRequest',
            title: 'Justification For Request'
        },
        {
            field: 'action',
            title: 'Action To Take'
        }
    ]
};
const convertDuration = (duration) => {
    const totalMinutes = Math.round(duration * 60);
    return `${Math.floor(totalMinutes / 60)}:${(totalMinutes % 60)
        .toString()
        .padStart(2, '0')}`;
};
exports.convertDuration = convertDuration;
const convertTimeTo24HourFormat = (timeIn12HourFormat) => {
    if (!timeIn12HourFormat || !(0, exports.validate12HourFormatTime)(timeIn12HourFormat)) {
        return timeIn12HourFormat;
    }
    const [time, modifier] = timeIn12HourFormat.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
        hours = '00';
    }
    if (modifier.toLowerCase() === 'pm' || modifier.toLowerCase() === 'p') {
        hours = (parseInt(hours, 10) + 12).toString();
    }
    return `${hours}:${minutes}`;
};
exports.convertTimeTo24HourFormat = convertTimeTo24HourFormat;
const validate12HourFormatTime = (timeIn12HourFormat) => {
    return (/^(1[0-2]|0?[1-9]):[0-5][0-9] (am|pm)$/gm.test(timeIn12HourFormat) ||
        /^(1[0-2]|0?[1-9]):[0-5][0-9] (A|P)$/gm.test(timeIn12HourFormat));
};
exports.validate12HourFormatTime = validate12HourFormatTime;
const addTimeTo12HourFormat = (timeIn12HourFormat, addHours, addMinutes) => {
    if (!(0, exports.validate12HourFormatTime)(timeIn12HourFormat)) {
        return timeIn12HourFormat;
    }
    const [currentHourString, currentMinuteString, period] = timeIn12HourFormat.split(/:| /);
    let currentHour = parseInt(currentHourString);
    let currentMinute = parseInt(currentMinuteString);
    if ((period.toLowerCase() === 'pm' || period.toLowerCase() === 'p') &&
        currentHour !== 12) {
        currentHour += 12;
    }
    else if ((period.toLowerCase() === 'am' || period.toLowerCase() === 'a') &&
        currentHour === 12) {
        currentHour = 0;
    }
    currentHour += addHours;
    currentMinute += addMinutes;
    currentHour += Math.floor(currentMinute / 60);
    currentMinute %= 60;
    let newPeriod = 'am';
    if (currentHour >= 12) {
        newPeriod = 'pm';
        if (currentHour > 12) {
            currentHour -= 12;
        }
    }
    return `${currentHour.toString().padStart(2, '0')}:${currentMinute
        .toString()
        .padStart(2, '0')} ${newPeriod}`;
};
exports.addTimeTo12HourFormat = addTimeTo12HourFormat;
const validateDate = (date) => {
    return luxon_1.DateTime.fromISO(date).isValid;
};
exports.validateDate = validateDate;
const calculateTimeDifferenceBetween12HourStrings = (timeString1, timeString2) => {
    if (!(0, exports.validate12HourFormatTime)(timeString1) ||
        !(0, exports.validate12HourFormatTime)(timeString2)) {
        return null;
    }
    const [time1, ampm1] = timeString1.split(' ');
    const [time2, ampm2] = timeString2.split(' ');
    const [hours1, minutes1] = time1.split(':').map(Number);
    const [hours2, minutes2] = time2.split(':').map(Number);
    const totalMinutes1 = ((hours1 % 12) +
        (ampm1.toLowerCase() === 'p' || ampm1.toLowerCase() === 'pm' ? 12 : 0)) *
        60 +
        minutes1;
    const totalMinutes2 = ((hours2 % 12) +
        (ampm2.toLowerCase() === 'p' || ampm2.toLowerCase() === 'pm' ? 12 : 0)) *
        60 +
        minutes2;
    let timeDifference = totalMinutes2 - totalMinutes1;
    if (timeDifference < 0) {
        timeDifference += 24 * 60;
    }
    return timeDifference / 60;
};
exports.calculateTimeDifferenceBetween12HourStrings = calculateTimeDifferenceBetween12HourStrings;
const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
};
exports.isNumeric = isNumeric;
const parseTravelTime = (travelTime, selectedDate, useMilitaryTime) => {
    const time = travelTime.split(' ')[0].split(':');
    let hours = parseInt(time[0]);
    const minutes = parseInt(time[1]);
    if (!useMilitaryTime) {
        if (hours === 12) {
            hours = 0;
        }
        const sign = travelTime.split(' ')[1];
        if (sign === 'pm' || sign === 'P') {
            hours += 12;
        }
    }
    return selectedDate.set({
        hour: hours,
        minute: minutes
    });
};
exports.parseTravelTime = parseTravelTime;
const getHoursAndMinutesFromDuration = (duration) => {
    const hours = Math.floor(duration);
    const minutes = Math.round((duration - hours) * 60);
    if (hours == 0) {
        return `${minutes} min`;
    }
    else if (hours && minutes == 0) {
        return `${hours} hr`;
    }
    return `${hours} hr ${minutes} min`;
};
exports.getHoursAndMinutesFromDuration = getHoursAndMinutesFromDuration;
